module.exports = __webpack_public_path__ + "img/scan (10).22c4d960.png";